module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-success"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Login successful")]), _c('div', {
    staticClass: "auth-token",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.code))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed0e086","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Success/Success.vue
// module id = 605
// module chunks = 1